import { useTranslation } from 'next-i18next';

const InlineSaveButton = () => {
  const { t } = useTranslation();

  return (
    <div className="absolute top-2 right-14 flex flex-col z-40">
      <button className="rounded-sm bg-black text-white text-base p-2 mb-1" type="submit">
        {t('common:save')}
      </button>
    </div>
  );
};
export default InlineSaveButton;
